var swiper = new Swiper(".spice-slider-gallery", {
  spaceBetween: 5,
  centeredSlides: true,
  speed: 3000,
  autoplay: {
    delay: 0,
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
});

// ............................................................................................

var swiper = new Swiper(".new-testi-slider", {
  slidesPerView: 3,
  spaceBetween: 25,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    768: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  }
});

// ............................................................................................

var swiper = new Swiper(".new-blogslider", {
  slidesPerView: 3.4,
  spaceBetween: 25,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      pagination: false
    },
    768: {
      slidesPerView: 2,
      pagination: false
    },
    1024: {
      slidesPerView: 3.4,
      pagination: false
    }
  }
});

// ............................................................................................

var swiper = new Swiper(".gift-embrace-ingredients", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  pagination: false,
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    768: {
      slidesPerView: 1
    },
    1024: {
      slidesPerView: 1
    }
  }
});

// ............................................................................................

$("ul.tabs li").click(function () {
  var tab_id = $(this).attr("data-tab");

  $("ul.tabs li").removeClass("current");
  $(".tab-content").removeClass("current");

  $(this).addClass("current");
  $("#" + tab_id).addClass("current");
});

// ............................................................................................

// jQuery(document).ready(function($) {
//     $("div[data-swatch-variant-id='41671454884018']").click(function(){

//         $(".spice-indicator--wrapper").find(".custom-cro--spices").css("display","none");
//         $(".spice-indicator--wrapper").find(".spice-level-two").css("display","inline-flex");
//     });
//     $("div[data-swatch-variant-id='44774807830706']").click(function(){

//         $(".spice-indicator--wrapper").find(".custom-cro--spices").css("display","none");
//         $(".spice-indicator--wrapper").find(".spice-level-four").css("display","inline-flex");
//     });
//     $("div[data-swatch-variant-id='44774807863474']").click(function(){

//         $(".spice-indicator--wrapper").find(".custom-cro--spices").css("display","none");
//         $(".spice-indicator--wrapper").find(".spice-level-five").css("display","inline-flex");
//     });
// });



// .......................... West Indies Curry .........................


jQuery(document).ready(function($) {
  $(document).on("click", "div[data-swatch-variant-id='41671454884018']", function() {
      $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
      $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44774807830706']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-four").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44774807863474']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-five").css("display", "inline-flex");
  });
});

jQuery(document).ready(function($) {
  $(document).on("click", "div[data-swatch-variant-id='41671454916786']", function() {
      $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
      $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44774807896242']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-four").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44774807929010']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-five").css("display", "inline-flex");
  });
});

// .......................... New World Chili .........................

jQuery(document).ready(function($) {
  $(document).on("click", "div[data-swatch-variant-id='41668943610034']", function() {
      $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
      $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44786118131890']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-three").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44786118164658']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-four").css("display", "inline-flex");
  });
});

jQuery(document).ready(function($) {
  $(document).on("click", "div[data-swatch-variant-id='41668976836786']", function() {
      $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
      $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44786118197426']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-three").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44786118230194']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-four").css("display", "inline-flex");
  });
});


// .......................... Old World Roast .........................


jQuery(document).ready(function($) {
  $(document).on("click", "div[data-swatch-variant-id='41668960911538']", function() {
      $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
      $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44786134974642']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });
});

jQuery(document).ready(function($) {
  $(document).on("click", "div[data-swatch-variant-id='41668960944306']", function() {
      $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
      $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='44786135007410']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

});



// .......................... Jovial Jerk .........................

jQuery(document).ready(function($) {
  $(document).on("click", "div[data-swatch-variant-id='43413016543410']", function() {
      $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
      $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='43413024211122']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-five").css("display", "inline-flex");
  });
});

jQuery(document).ready(function($) {
  $(document).on("click", "div[data-swatch-variant-id='43668214448306']", function() {
      $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
      $(".spice-indicator--wrapper").find(".spice-level-two").css("display", "inline-flex");
  });

  $(document).on("click", "div[data-swatch-variant-id='43668214481074']", function() {
    $(".spice-indicator--wrapper").find(".custom-cro--spices").hide();
    $(".spice-indicator--wrapper").find(".spice-level-five").css("display", "inline-flex");
  });

});


// ........................................................................

$(document).ready(function() {
  function updateShippingInfo() {
    console.log('updateShippingInfo...');
    $.getJSON('/cart.js', function(cart) {
      var cartTotal = parseFloat(cart.total_price) / 100; 
      console.log(cart.total_price);
      console.log(cartTotal);
      if (cartTotal > 50) {
        $('#shipping-info').html('<span class="total-cart-price-highlight">Congratulations!</span> You got free shipping');
      } else {
        var amountNeeded = (50 - cartTotal).toFixed(2);
        $('#shipping-info').html('You need <span class="total-cart-price-highlight">$' + amountNeeded + '</span> more for free shipping');
      }
    });
  }
  updateShippingInfo();
  // var intervalId = setInterval(updateShippingInfo, 1000);
  $(document).on('ajax:complete', function() {
    updateShippingInfo();
  });
  $(document).on('cart:updated', function() {
    updateShippingInfo();
  });
});




// ........................................................................
















